
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as CheckIcon } from "../fontello/icons/svg/ic_check.svg"


const Check = ({ ...props }) => (
  <SvgIcon
    component={CheckIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Check
